'use strict';exports.__esModule = true;var _validate = require('../../utils/validate');
var _constants = require('./constants');

var validate = function validate(values, props) {
  var errors = {};

  if (values.loginType === _constants.loginType.LOGIN_VIA_PASSWORD &&
  !((0, _validate.emailRegexValidation)(values.email) || (0, _validate.phoneRegexValidation)(values.email))) {
    errors.email = 'required';
  }
  if (values.loginType === _constants.loginType.LOGIN_VIA_SMS && !values.phone) {
    errors.phone = 'required';
  }
  if (!values.password) {
    errors.password = 'required';
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/loginContainer/validate.js
// module id = 3063
// module chunks = 0